import { WavyCircleIcon } from '@icons/WavyCircle';
import { NumberItem } from '@/components/RecipeStep/styles';
import React from 'react';

export const NumberItemComponent = ({
  step,
  dataTest,
  dataIndex,
}: {
  step: number;
  dataTest: string;
  dataIndex: number | null;
}) => (
  <div className="w-20 break-inside-auto" data-index={dataIndex} data-test={dataTest}>
    <div className="relative mr-3 w-11 h-11 md:mr-10 break-inside-auto">
      <WavyCircleIcon />
      <NumberItem tag="div" type="xxxs">
        {step}
      </NumberItem>
    </div>
  </div>
);
